export default {
      id: "ic_header_right-usage",
      viewBox: "0 0 8 12",
      url: "/" + "images/icons.3.109.2.svg#ic_header_right-usage",
      toString: function () {
        return this.url;
      }
    }